import Dialog from './src/';
import { TYPE } from './config';

const MESSAGE = {

  install (Vue) {
    Vue.prototype.$tip = (text) => {
      if (!text) {
        return;
      }
      return new Promise((resolve, rejects) => {
        Dialog.open({
          text,
          type: TYPE.tip,
          confirm: () => {
            resolve();
          }
        });
      });
    }

    Vue.prototype.$alert = (text) => {
      if (!text) {
        return;
      }
      return new Promise((resolve) => {
        Dialog.open({
          text,
          type: TYPE.alert,
          confirm: () => {
            resolve();
          }
        });
      });
    }

    Vue.prototype.$confirm = (text) => {
      if (!text) {
        return;
      }
      return new Promise((resolve, rejects) => {
        Dialog.open({
          text,
          type: TYPE.confirm,
          confirm: () => {
            resolve();
          },
          cancel: () => {
            rejects();
          }
        });
      });
    }
  }

}

export default MESSAGE;

